<template>
  <button
    v-bind="$attrs"
    class="select-none rounded-lg bg-highlight px-4 py-2 text-white duration-300 ease"
    :class="theme === 'light' && !special ? 'hover:bg-highlight-4' : 'hover:bg-highlight-2'"
    :disabled="disabled"
    :type="type">
    <span><i :class="icon" /></span>
    <span>{{ label }}</span>
  </button>
</template>

<script setup lang="ts">
import type { EffectiveTheme } from '@/helpers/settings';

const { type = 'button' } = defineProps<{
  disabled?: boolean;
  icon?: string;
  label?: string;
  type?: HTMLButtonElement['type'];
  special?: boolean;
  theme?: EffectiveTheme;
}>();
</script>
